import "./SeguimientoDevolucion.css";

const estadosDevolucion = [
  "PENDIENTE",
  "PRODUCTO_RECIBIDO",
  "APROBADA",
  "RECHAZADA",
  "REEMBOLSADO"
];

const estadosReembolso = [
  "PENDIENTE",
  "APROBADA",
  "RECHAZADA",
  "REEMBOLSADO"
];

const SeguimientoDevolucion = ({ devolucion }) => {
  if (!devolucion) return null;

  // Si el estado es RECHAZADA, solo mostramos hasta ese punto
  const esRechazada = devolucion.estado === "RECHAZADA";
  const timelineEstados = devolucion.accion === "REEMBOLSO" ? estadosReembolso : estadosDevolucion;
  
  // Filtramos el timeline si es rechazada para no mostrar pasos posteriores innecesarios
  const estadosAMostrar = esRechazada 
    ? timelineEstados.slice(0, timelineEstados.indexOf("RECHAZADA") + 1)
    : timelineEstados.filter(e => e !== "RECHAZADA" || devolucion.estado === "RECHAZADA");

  const indexActual = estadosAMostrar.indexOf(devolucion.estado);

  return (
    <div className="seguimiento-card">
      <div className="seguimiento-header">
        <div className="header-title">
          <span className="icon">🔁</span>
          <h3>Seguimiento de {devolucion.accion.toLowerCase()}</h3>
        </div>
        <span className={`badge-estado ${devolucion.estado.toLowerCase()}`}>
          {devolucion.estado.replaceAll("_", " ")}
        </span>
      </div>

      <div className="info-grid">
        <div className="info-item">
          <label>Motivo</label>
          <p>{devolucion.motivo}</p>
        </div>
        {devolucion.comentario && (
          <div className="info-item full-width">
            <label>Comentario del cliente</label>
            <p className="comentario-text">"{devolucion.comentario}"</p>
          </div>
        )}
      </div>

      <div className="timeline-container">
        <div className="timeline-track">
          {estadosAMostrar.map((estado, i) => {
            const isCompleted = i < indexActual;
            const isCurrent = i === indexActual;
            const isLast = i === estadosAMostrar.length - 1;

            return (
              <div 
                key={estado} 
                className={`timeline-node ${isCompleted ? "completed" : ""} ${isCurrent ? "current" : ""} ${estado === "RECHAZADA" ? "rejected" : ""}`}
              >
                <div className="node-marker">
                  {isCompleted ? "✓" : (i + 1)}
                </div>
                <div className="node-content">
                  <span className="node-text">{estado.replaceAll("_", " ")}</span>
                </div>
                {!isLast && <div className="node-connector"></div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SeguimientoDevolucion;